import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { IoMdClose, IoMdSearch } from "react-icons/io";
import { IoCartOutline, IoChevronDown, IoChevronUp } from "react-icons/io5";

import { SlidingSideMenuContainer } from "./styled/sideMenu";

export default function SlidingSideMenu({
  clickSideMenu,
  setClickSideMenu,
  url,
  menus,
  handleLogoutModal,
  theme,
  homepageInfo,
}) {
  const navigate = useNavigate();
  const [active, setActive] = useState("");

  const user = useSelector((state) => state?.user?.data[0]);

  const links = {
    0: "company",
    1: "productsList",
    2: "portfolio",
    3: "shoppingNotice",
  };

  const pageNavigation = (path) => {
    setClickSideMenu(false);
    navigate(path);
  };

  const tnb = user
    ? [
        { label: "마이페이지", onClick: () => pageNavigation(`/shop/mypage`) },
        { label: "로그아웃", onClick: handleLogoutModal },
      ]
    : [
        {
          label: "로그인",
          onClick: () => pageNavigation(`/shop${url ? `/${url}` : ""}/login`),
        },
        // { label: "회원가입", onClick: () => pageNavigation("/type") },
      ];

  return (
    <SlidingSideMenuContainer className={`theme-${theme} ${clickSideMenu ? "active" : "inactive"}`}>
      <div className="sideMenuInfo">
        <button onClick={() => pageNavigation("/")} className="home">
          <span>MONOTI</span>
        </button>
        <div className="actions">
          <button onClick={() => pageNavigation(`/shop/${url ? `${url}/` : ""}search?keyword=`)}>
            <IoMdSearch />
          </button>
          <button onClick={() => pageNavigation(`/shop/mypage/cart`)}>
            <IoCartOutline />
          </button>
          <button onClick={() => setClickSideMenu(false)} className="close">
            <IoMdClose />
          </button>
        </div>
      </div>
      {menus.length > 0 && (
        <ToggleMenuList
          title="메뉴"
          type="menus"
          active={active}
          setActive={setActive}
          items={menus.map((item) => ({
            label: item.afterMenuName || item.beforeMenuName,
            onClick: () => pageNavigation(`/shop/${url}/${links[item.menuType] || ""}`),
          }))}
        />
      )}
      <ToggleMenuList
        title="서비스"
        type="monoti"
        active={active}
        setActive={setActive}
        items={[
          { label: "대시보드", onClick: () => pageNavigation("/mypage") },
          ...serviceMenu.map((item) => ({
            label: item.label,
            onClick: () => pageNavigation(item.label === "e층창고" ? "/shop" : item.link),
          })),
        ]}
      />
      <ul className="tnb">
        {tnb.map((item, i) => (
          <li key={i} onClick={item.onClick}>
            {item.label}
          </li>
        ))}
      </ul>
    </SlidingSideMenuContainer>
  );
}

function ToggleMenuList({ title, type, active, setActive, items }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.height = active === type ? `${ref.current.scrollHeight}px` : "0px";
  }, [active, type]);

  return (
    <div className="wrapper">
      <button className="toggle" onClick={() => setActive(active === type ? "" : type)}>
        <span>{title}</span>
        <span className="icon">{active === type ? <IoChevronUp /> : <IoChevronDown />}</span>
      </button>
      <ul ref={ref}>
        {items.map((item, i) => (
          <li key={i} onClick={item.onClick}>
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
